import { Tooltip } from "@mui/material";
import React from "react";

function NoteCell({ note = "" }: { note?: string }) {
  return (
    <Tooltip title={note}>
      <span
        style={{
          paddingTop: "16px",
          paddingBottom: "16px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {note}
      </span>
    </Tooltip>
  );
}

export default NoteCell;
